import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import config from '@app/config';
import { useOS } from '@app/hooks/useOs';
import { useAction } from '@hook/useAction';

const OpenInApp = () => {
  const action = useAction();
  const { t } = useTranslation();
  const { isAndroid, isIOS } = useOS();

  let storeLink: string | undefined;
  if (isAndroid) {
    storeLink = config.androidPlayStoreLink;
  } else if (isIOS) {
    storeLink = config.iosAppStoreLink;
  }

  if (!storeLink) {
    return null;
  }

  return (
    <a
      role="button"
      href={storeLink}
      title={t('button:use_the_app')}
      className={classNames(
        action.primary,
        'fixed bottom-0 left-1/2 -translate-x-1/2 mb-8 shadow'
      )}
    >
      {t('button:use_the_app')}
    </a>
  );
};

export default OpenInApp;
